import { createContext, useContext, useState, useCallback } from 'react';
import { useHotkeys } from '../hooks/useHotkeys';
import { GlobalSearch } from '../components/global/GlobalSearch';
import { KeyboardShortcutsHelp } from '../components/global/KeyboardShortcutsHelp';

const HotkeysContext = createContext({
  openSearch: () => {},
  openShortcutsHelp: () => {},
});

export function useGlobalHotkeys() {
  return useContext(HotkeysContext);
}

export function HotkeysProvider({ children }) {
  const [searchOpen, setSearchOpen] = useState(false);
  const [shortcutsHelpOpen, setShortcutsHelpOpen] = useState(false);

  const openSearch = useCallback(() => setSearchOpen(true), []);
  const openShortcutsHelp = useCallback(() => setShortcutsHelpOpen(true), []);

  // Register global hotkeys
  useHotkeys({
    'ctrl+k': openSearch,
    'cmd+k': openSearch,
    '?': openShortcutsHelp,
  });

  return (
    <HotkeysContext.Provider value={{ openSearch, openShortcutsHelp }}>
      {children}
      <GlobalSearch open={searchOpen} onOpenChange={setSearchOpen} />
      <KeyboardShortcutsHelp open={shortcutsHelpOpen} onOpenChange={setShortcutsHelpOpen} />
    </HotkeysContext.Provider>
  );
}
